export default __webpack_public_path__ + "static/media/search-sku.52bd4d21.png";